<template>
  <div>
    <div class="action d-flex justify-end" :class="{ 'old-action': detailPeriod.index == 7 }">
      <v-tooltip bottom>
        <template v-slot:activator="{ on, attrs }">
          <v-btn icon @click="() => openBillDetail(kind)" v-bind="attrs" v-on="on">
            <v-icon>mdi-eye</v-icon>
          </v-btn>
        </template>
        <span class="white--text">Xem chi tiết hoá đơn</span>
      </v-tooltip>
      <v-tooltip bottom v-if="detailPeriod.index == 7 || kind === 'decen'">
        <template v-slot:activator="{ on, attrs }">
          <div class="button-note">
            <v-btn v-if="$auth.policies['update-note-period']" icon @click="openNoteDialog" v-bind="attrs" v-on="on">
              <v-icon>mdi-file-document-edit</v-icon>
            </v-btn>
            <div v-if="report.isUseNote" class="noti-note"></div>
          </div>
        </template>
        <span class="white--text">Bổ sung ghi chú</span>
      </v-tooltip>
      <v-tooltip v-if="viewIsPaid && kind === 'decen'" bottom>
        <template v-slot:activator="{ on, attrs }">
          <v-btn v-if="!report[kind].isPaid" icon @click="updateStatus" v-bind="attrs" v-on="on">
            <v-icon>mdi-checkbox-marked-circle-outline</v-icon>
          </v-btn>
          <v-btn v-else icon @click="updateStatus" v-bind="attrs" v-on="on">
            <img :src="InfomationOffIcon" />
          </v-btn>
        </template>
        <span class="white--text">{{ !report[kind].isPaid ? 'Đã thu' : 'Chưa thu' }}</span>
      </v-tooltip>
      <!-- <v-tooltip bottom>
        <template v-slot:activator="{ on, attrs }">
          <div class="button-ticket">
            <v-btn icon @click="() => openTicketDialog()" v-bind="attrs" v-on="on">
              <v-icon>mdi-message-alert</v-icon>
            </v-btn>
            <div v-if="report[kind].amountTicket && report[kind].amountTicket > 0" class="count-ticket text-caption">
              {{ report[kind].amountTicket }}
            </div>
          </div>
        </template>
        <span class="white--text">{{ !report[kind].isPaid ? 'Đã thu' : 'Chưa thu' }}</span>
      </v-tooltip> -->
    </div>
    <EditNotePeriod ref="edit-note" />
    <DetailedBillDialog ref="detail-bill" />
    <DetailBillDialog ref="detail-bill-dialog" />
    <DialogTicket ref="dialog-ticket" />
  </div>
</template>
<script>
import EditNotePeriod from './EditNotePeriod.vue'
import DetailedBillDialog from './detailedBillDialog.vue'
import DialogTicket from './DialogTicket.vue'
import DetailBillDialog from './DetailBillDialog.vue'
import InfomationOffIcon from '@/assets/collect.svg'
import { mapActions, mapGetters } from 'vuex'
export default {
  props: {
    report: Object,
    viewIsPaid: Boolean,
    kind: String,
  },
  data() {
    return {
      isEditNote: false,
      isOpenDialog: false,
      InfomationOffIcon,
    }
  },
  components: {
    EditNotePeriod,
    DialogTicket,
    DetailedBillDialog,
    DetailBillDialog,
  },
  computed: {
    ...mapGetters({
      detailPeriod: 'tuitionFeePeriod/detailPeriod',
    }),
  },
  methods: {
    ...mapActions({
      setReport: 'tuitionFeeReport/setReport',
      editStatusPaid: 'tuitionFeeReport/editStatusPaid',
    }),
    openNoteDialog() {
      this.setReport(this.report)
      this.$refs['edit-note'].openDialog()
    },
    openTicketDialog() {
      this.$refs['dialog-ticket'].openDialog(this.report.id, this.kind)
    },
    openBillDetail(kind) {
      this.setReport(this.report)
      let ref = 'detail-bill-dialog'
      // if (this.detailPeriod.index == 7) ref = 'detail-bill'
      this.$refs[ref].openDialog(kind)
    },
    updateStatus() {
      this.$dialog.confirm({
        title: 'Xác nhận cập nhật trạng thái?',
        text: `<p style=" margin-bottom: 0px;">Thay đổi trạng thái thanh toán thành ${
          this.report[this.kind].isPaid
            ? '<span class="red--text">Chưa thu<span>'
            : '<span class="success--text">Đã thu<span>'
        } sẽ ảnh hưởng đến tổng số tiền đã thu.</p><span>Bạn có muốn tiếp tục?</span>`,
        okText: 'Xác nhận',
        cancelText: 'Hủy',
        done: async () => {
          try {
            this.$loading.active = true
            const params = {
              id: this.report.id,
            }
            params.kind = this.kind
            params.isPaid = !this.report[this.kind].isPaid

            await this.editStatusPaid(params)
            this.$alert.success('Đã cập nhật thành công!')
          } catch (e) {
            this.$alert.error({ title: 'Lỗi kết nối', description: 'Không thể cập nhật. Vui lòng thử lại' })
          } finally {
            this.$loading.active = false
          }
        },
      })
    },
  },
}
</script>
<style lang="scss" scoped>
.button-ticket {
  position: relative;
  .count-ticket {
    position: absolute;
    right: 0;
    top: 0;
    background-color: red;
    width: 18px;
    line-height: 15px;
    padding: 0;
    font-size: 10px !important;
    text-align: center;
    border-radius: 10px;
    color: white;
  }
}
.button-note {
  position: relative;
  .noti-note {
    position: absolute;
    left: 6px;
    top: 5px;
    background-color: red;
    width: 8px;
    height: 8px;
    border-radius: 10px;
  }
}
.action {
  min-width: 70px;
}
.old-action {
  min-width: 108px;
}
</style>
